import {
	createSlice,
} from '@reduxjs/toolkit';
import {
	CollectionJson,
} from '@@types/Collection';
import {
	SpecificationJson,
} from '@layouts/Pages/PageSpecifications';

export interface StoreSpecifications {
	instance: CollectionJson<SpecificationJson>;
}

// Define the initial state using that type
const initialState: StoreSpecifications = {
	instance: {
		collection: [],
		count: 0,
	},
};

export const specificationsSlice = createSlice({
	initialState,
	name: 'specifications',
	reducers: {
		clearSpecifications: (state) => {
			state.instance = initialState.instance;
		},
		setSpecification: (state, action) => {
			const findSpecification = state.instance.collection.find((specification: SpecificationJson) => specification.id && action.payload.id && specification.id === action.payload.id);

			if (findSpecification) {
				const specifications = state.instance.collection.map((specification: SpecificationJson) => {
					if (specification.id && action.payload.id && specification.id === action.payload.id) {
						return action.payload;
					} else {
						return specification;
					}
				});
				state.instance.collection = specifications;
			} else {
				state.instance.count = state.instance.count + 1;
				state.instance.collection = [
					...state.instance.collection,
					action.payload,
				];
			}
		},
		setSpecifications: (state, action) => {
			state.instance = action.payload;
		},
	},
});

export const {
	clearSpecifications,
	setSpecification,
	setSpecifications,
} = specificationsSlice.actions;

export const specificationsReducer = specificationsSlice.reducer;
